import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import SectionWrapper from 'components/SectionWrapper'
import { RU } from 'constants/countries'
import { GOODS_TYPES } from 'constants/sales'
import { LocalizationContext } from 'contexts/Localization'
import { dnaAbout, biomeAbout, wgsAbout } from 'routes'

import CartDelivery from './components/CartDelivery'
import CartProduct from './components/CartProduct'
import CartSummary from './components/CartSummary'

/**
 * CartGoodsBlock
 *
 * @param {object} props - properties of component
 * @returns {node} CartGoodsBlock
 */
const CartGoodsBlock = props => {
  const {
    cart,
    texts,
    decreaseGoods,
    increaseGoods,
    toggleSubscription,
    submitPromocode,
    closePromocode,
    isCartInitOrUpdate,
    changeDeliveryType,
  } = props
  const { goods, deliveryType, deliveryAvailableTypes, isOrderCollected } = cart
  const { locale, dict, paths, currentCountry, sales } = useContext(
    LocalizationContext,
  )
  const isDisabled = isCartInitOrUpdate || isOrderCollected

  const isRu = React.useMemo(() => locale === RU, [locale])

  const CartBiome = sales.goods && sales.goods[GOODS_TYPES.biome].isActive && (
    // (!goods[GOODS_TYPES.biome].amount && isRu ?
    //     <RowIndented>
    //          <Col>
    // <CartEmptyItemNew
    //   dict={dict}
    //   texts={texts}
    //   boxes={`${paths.cdn_global}/boxes/${
    //     isRu ? 'biome-left-new' : 'biome-cart-new'
    //   }`}
    //   productType={GOODS_TYPES.biome}
    //   productInfo={sales.goods[GOODS_TYPES.biome]}
    //   productConfig={sales.goods[GOODS_TYPES.biome]}
    //   discount={sales.goods[GOODS_TYPES.biome].discount}
    //   currencyCode={sales.currency}
    //   precision={sales.precision}
    //   handleIncrease={increaseGoods}
    //   intlCode={currentCountry.intlCode}
    //   isDisabled={isDisabled}
    //   isCartInitOrUpdate={isCartInitOrUpdate}
    // />
    //          </Col>
    //              </RowIndented>
    // )
    // :
    <CartProduct
      boxes={`${paths.cdn_global}/boxes/${
        isRu ? 'biome-left-new' : 'biome-cart-new'
      }`}
      currencyCode={sales.currency}
      dict={dict}
      productInfo={goods[GOODS_TYPES.biome]}
      productConfig={sales.goods[GOODS_TYPES.biome]}
      productType={GOODS_TYPES.biome}
      precision={sales.precision}
      isСontrolsHidden={sales.isGroupon}
      handleDecrease={decreaseGoods}
      handleIncrease={increaseGoods}
      toggleSubscription={toggleSubscription}
      intlCode={currentCountry.intlCode}
      texts={texts}
      discountLabel={texts.labels.off}
      discount={sales.goods[GOODS_TYPES.biome].discount}
      titleLink={biomeAbout.link(locale)}
      isDisabled={isDisabled}
      isCartInitOrUpdate={isCartInitOrUpdate}
    />
  )

  return (
    <>
      <SectionWrapper isWideToDesktop={true} isOverflowHidden={true}>
        {/* We need this div to calculate a child's position in css */}
        <div>
          {!isRu && CartBiome}
          {sales.goods && sales.goods[GOODS_TYPES.dna].isActive && (
            <CartProduct
              boxes={`${paths.cdn_global}/boxes/${
                isRu ? 'dna-left-new' : 'dna-cart-new'
              }`}
              currencyCode={sales.currency}
              dict={dict}
              productInfo={goods[GOODS_TYPES.dna]}
              productConfig={sales.goods[GOODS_TYPES.dna]}
              productType={GOODS_TYPES.dna}
              precision={sales.precision}
              handleDecrease={decreaseGoods}
              handleIncrease={increaseGoods}
              intlCode={currentCountry.intlCode}
              texts={texts}
              titleLink={dnaAbout.link(locale)}
              discountLabel={texts.labels.off}
              discount={sales.goods[GOODS_TYPES.dna].discount}
              isDisabled={isDisabled}
              isCartInitOrUpdate={isCartInitOrUpdate}
            />
          )}
          {isRu && CartBiome}
          {sales.goods && sales.goods[GOODS_TYPES.wgs].isActive && (
            <CartProduct
              boxes={`${paths.cdn_global}/boxes/wgs-left-new`}
              currencyCode={sales.currency}
              dict={dict}
              productInfo={goods[GOODS_TYPES.wgs]}
              productConfig={sales.goods[GOODS_TYPES.wgs]}
              productType={GOODS_TYPES.wgs}
              precision={sales.precision}
              handleDecrease={decreaseGoods}
              handleIncrease={increaseGoods}
              intlCode={currentCountry.intlCode}
              texts={texts}
              titleLink={wgsAbout.link(locale)}
              discountLabel={texts.labels.off}
              discount={sales.goods[GOODS_TYPES.wgs].discount}
              isDisabled={isDisabled}
              isCartInitOrUpdate={isCartInitOrUpdate}
            />
          )}
        </div>
      </SectionWrapper>
      <SectionWrapper isWideToDesktop={true} isOverflowHidden={false}>
        {cart.sum && cart.sum.amount > 0 && (
          <>
            <CartDelivery
              isCartInitOrUpdate={isCartInitOrUpdate}
              isSinglePageCart={cart.isSinglePage}
              cost={cart.sum.delivery}
              isFree={cart.sum.isDeliveryFree}
              texts={texts}
              deliveryType={deliveryType}
              deliveryAvailableTypes={deliveryAvailableTypes}
              changeDeliveryType={changeDeliveryType}
              isDisabled={isDisabled}
              precision={sales.precision}
            />
            <CartSummary
              texts={texts}
              submitPromocode={submitPromocode}
              closePromocode={closePromocode}
              cart={cart}
              isLoading={isCartInitOrUpdate}
            />
          </>
        )}
      </SectionWrapper>
    </>
  )
}

CartGoodsBlock.propTypes = {
  /** State of cart */
  cart: PropTypes.object.isRequired,

  /** Function to reset promocode state when close input */
  closePromocode: PropTypes.func.isRequired,

  /** Decrease amount of current goods in the cart */
  decreaseGoods: PropTypes.func.isRequired,

  /** Increase amount of current goods in the cart */
  increaseGoods: PropTypes.func.isRequired,

  /** Send promo code to server for check, then apply */
  submitPromocode: PropTypes.func.isRequired,

  /** Object with localized texts for cart page */
  texts: PropTypes.object.isRequired,

  /** ToggleHorizontal subscription callback */
  toggleSubscription: PropTypes.func.isRequired,

  /** Hide price when cart init or update  */
  isCartInitOrUpdate: PropTypes.bool,

  /** Select delivery type for russian order */
  changeDeliveryType: PropTypes.func,
}

CartGoodsBlock.defaultProps = {}

export default CartGoodsBlock
